import { Link } from 'react-router-dom';

const Footer = () => {
  const handleNavClick = (hash: string) => {
    const element = document.getElementById(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-[1280px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <p className="text-gray-400 text-sm">HR excellence for sport</p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Navigate</h4>
            <div className="space-y-3">
              <Link to="/about" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                About
              </Link>
              <Link to="/services" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Services
              </Link>
              <button
                onClick={() => handleNavClick('why-us')}
                className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
              >
                Why Us
              </button>
              <button
                onClick={() => handleNavClick('contact')}
                className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
              >
                Contact
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <div className="space-y-3">
              <Link to="/services" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Personal Brand Management
              </Link>
              <Link to="/services" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Recruitment
              </Link>
              <Link to="/services" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Training & Development
              </Link>
              <Link to="/services" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Coaching & Mentoring
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Stay Updated</h4>
            <p className="text-gray-400 text-sm mb-4">Get insights on sport and people performance</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-[#1A2B3F] border border-gray-700 rounded-lg px-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#0066FF]"
              />
              <button className="bg-[#0066FF] w-10 h-10 flex items-center justify-center rounded-lg hover:bg-[#0052CC] transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2025 Decimal Esporte. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
